import { Card, Skeleton } from 'antd'
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons'

interface StatCardProps {
  title: string
  value: string | number
  icon?: React.ReactNode
  color?: 'blue' | 'green' | 'purple' | 'orange' | 'red'
  trend?: {
    value: number
    isPositive: boolean
  }
  suffix?: string
  loading?: boolean
  /** 点击卡片时触发，用于跳转详情等 */
  onClick?: () => void
}

const StatCard = ({
  title,
  value,
  icon,
  color = 'blue',
  trend,
  suffix,
  loading = false,
  onClick,
}: StatCardProps) => {
  const colorMap = {
    blue: '#3b82f6',
    green: '#10b981',
    purple: '#8b5cf6',
    orange: '#f59e0b',
    red: '#ef4444',
  }

  const trendColor = trend?.isPositive ? '#10b981' : '#ef4444'
  const TrendIcon = trend?.isPositive ? ArrowUpOutlined : ArrowDownOutlined

  if (loading) {
    return (
      <Card className="h-full">
        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>
    )
  }

  return (
    <Card
      className={`h-full transition-shadow duration-300 ${onClick ? 'cursor-pointer hover:shadow-lg' : 'hover:shadow-lg'}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div>
          <div className="text-gray-500 text-sm mb-2">{title}</div>
          <div className="flex items-baseline">
            <div className="text-2xl font-bold" style={{ color: colorMap[color] }}>
              {value}
            </div>
            {suffix && <span className="text-gray-500 ml-1">{suffix}</span>}
          </div>
        </div>
        
        {icon && (
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${colorMap[color]}15` }}
          >
            <div style={{ color: colorMap[color], fontSize: '18px' }}>
              {icon}
            </div>
          </div>
        )}
      </div>

      {trend && (
        <div className="mt-4 flex items-center">
          <TrendIcon style={{ color: trendColor, marginRight: 4 }} />
          <span style={{ color: trendColor, fontSize: '14px' }}>
            {trend.isPositive ? '+' : ''}{trend.value.toFixed(1)}%
          </span>
          <span className="text-gray-500 text-sm ml-2">较昨日</span>
        </div>
      )}

      {onClick && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <div className="text-xs text-gray-500">
            点击查看详情
          </div>
        </div>
      )}
    </Card>
  )
}

export default StatCard